<template>
  <div class="page-grade-post" v-if="ready">
    <router-view />
  </div>
</template>
<script>
import './index.less';

export default {
  name: 'Post',
  data() {
    return {
      ready: false
    };
  },
  async created() {
    await this.guardAccess();
  },
  methods: {
    /**
     * @function guardAccess
     * @desc 检查成绩单寄送开放时间
     */
    async guardAccess() {
      this.$loading.show();
      try {
        const sendOpen = await this.$ddl.isOver('成绩单寄送开放');
        if (!sendOpen) {
          this.$message.error('暂未开放');
          this.$redirectToMyHsylc();
          return;
        }
        this.ready = true;
      } finally {
        this.$loading.hide();
      }
    }
  }
};
</script>
